import mitt from 'mitt';

export default emitter = mitt();